( function ( $ ) {
	function toggleNav() {
		const overlay = $( '.navbar-overlay' ),
			toggler = $( '.navbar-menu-toggle' ),
			body = $('body');

		toggler.toggleClass('active')
		overlay.fadeToggle( 300, function () {
			overlay.toggleClass( 'active' );
		});

		body.toggleClass('no-scroll');
	}

	$( '.navbar-menu-toggle' ).click( function ( e ) {
		toggleNav();
	} );

	$( '.scroll-to-link' ).click( function ( e ) {
		e.preventDefault();
		toggleNav();
		$('html, body').animate({
			scrollTop: $($(this).attr('href')).offset().top - 100
		}, 300);
		return false;
	} );

	$( '.article-header__scroll a' ).click( function ( e ) {
		e.preventDefault();

		const logoHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--indy-logo-height-desktop-px'));
		const logopadding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--indy-logo-padding-height-desktop-px'));
		const headerHeight = logoHeight+(logopadding*2);



		//rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
		console.log(logoHeight);
		console.log(logopadding);
		console.log(headerHeight);


		const scrollID = $(this).attr('href');
		$('html, body').animate({
			scrollTop: $(scrollID).offset().top - headerHeight + 20
		}, 700, );
		return false;
	} );

	function checkHeaderPosition() {
		const overlay = $( '.navbar-overlay' );

		if (!overlay.hasClass('active')) {
			let scrollTop = $(window).scrollTop();
			if (scrollTop >= 30) {
				$('.header').addClass("scrolled");
			} else {
				$('.header').removeClass("scrolled");
			}
		}
	}
	$(document).ready(function() { checkHeaderPosition(); });
	$(document).scroll(function() { checkHeaderPosition(); });

} )( jQuery );
